/**
 * Tournament data organized by year
 * Contains all the Black owLs' tournament participation and achievements
 */
export const tournamentData = {
    '2018': [
        {
            title: 'SQTR Turnuvası',
            logo: 'SQTR_turnuvasi.png',
            placement: 'Şampiyonu',
            result: 'gold-medal.png',
            // description: 'İlk uluslararası turnuva katılımımız',
            date: '2018'
        }
    ],
    '2019': [
        {
            title: 'Official Squad Showdown Season 3',
            logo: 'OSS_logo.png',
            placement: 'Yari Final',
            result: 'bronze-medal.png',
            // description: 'Yıldızlar Ligi final mücadelesi',
            date: '2019'
        },
        {
            title: 'Squad Rivals Tier 1',
            logo: 'Squad_Rivals.png',
            placement: 'Semi Finalist',
            result: 'bronze-medal.png',
            // description: 'Üst düzey rekabet',
            date: '2019'
        }
        
    ],
    '2020': [
        {
            title: 'Official Tournament (OISC)',
            logo: 'OISC.png',
            placement: 'Semi Finalist w/IG',
            result: 'bronze-medal.png',
            // description: 'Dünya finalistleri',
            date: '2020'
        },
        {
            title: 'Best Of Turks',
            logo: 'BoT.png',
            placement: 'Şampiyonu',
            result: 'gold-medal.png',
            // description: 'En büyük başarımız - dünya çeyrek finali',
            date: '2020'
        }
    ],
    '2021': [
        {
            title: 'Squad Open Tournament',
            logo: 'SOT.png',
            placement: 'Semi Finals 4th w/H',
            result: 'bronze-medal.png',
            // description: 'Uluslararası arenada yarı final',
            date: '2021'
        },
        {
            title: 'SGC Season 1',
            logo: 'SC_Logo.png',
            placement: 'Semi Finals',
            result: 'bronze-medal.png',
            // description: 'Yeni formatta yarı final',
            date: '2021'
        }
    ],
    '2022': [
        {
            title: 'Squad Charity League',
            logo: 'SCL.png',
            placement: 'Finals w/RvN',
            result: 'silver-medal.png',
            // description: 'Hayır turnuvasında final',
            date: '2022'
        },
        {
            title: 'Squad Rivals Finals',
            logo: 'Squad_Rivals.png',
            placement: '2nd w/RvN',
            result: 'silver-medal.png',
            // description: 'Üst düzey rekabet',
            date: '2022'
        }
        
    ],
    '2023': [
        {
            title: 'Squad Rivals',
            logo: 'Rivals.png',
            placement: 'Tier 2 Champion',
            result: 'gold-medal.png',
            // description: 'Üst düzey rekabet',
            date: '2023'
        }
    ]
};

/**
 * Returns a formatted string describing the team's achievements in a given year
 * @param {string} year - The year to get achievements for
 * @returns {string} A summary of achievements
 */
export const getYearSummary = (year) => {
    const tournaments = tournamentData[year];
    if (!tournaments || tournaments.length === 0) {
        return 'Bu yıl için kayıtlı başarı bulunamadı.';
    }

    const championshipsCount = tournaments.filter(t =>
        t.placement.includes('Champion') || t.placement.includes('1st Place')
    ).length;

    const finalsCount = tournaments.filter(t =>
        t.placement.includes('Finalist') || t.placement.includes('Finals') || t.placement.includes('Runner-up')
    ).length;

    const totalTournaments = tournaments.length;
    return ""
    //return `${year} yılında toplam ${totalTournaments} turnuvaya katıldık, ${championshipsCount} şampiyonluk ve ${finalsCount} final başarısı elde ettik.`;
};